import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import noop from "../../../services/noop";
import QuestionPreview from "../QuestionPreview";
import useStyles from "./styles";
import { extractContent } from "../../../services/commons";

const AnswerScaleNps = (props) => {
  const styles = useStyles(props);

  const [selected, setSelected] = useState(props.value);

  const handleChange = (num) => {
    setSelected(num);
    props.handleChange(num);
  };

  useEffect(() => {
    if (props.value) {
      setSelected(props.value);
    } else {
      setSelected(null);
    }
  }, [props.value]);

  return (
    <div className={styles.questionWrapper}>
      <fieldset aria-required={props.required}>
        <legend>
          <QuestionPreview
            question={props.question}
            required={props.required}
            helperText={props.helperText}
            styleNps={true}
          />
          <p className={styles.offscreenText}>
            0 being not at all likely and 10 being very likely
          </p>
        </legend>
        <div className={`${styles.scaleWrapper}`}>
          <div className={`${styles.scaleContainer}`} role="radiogroup">
            {props.choices.map(({ value }) => (
              <>
                <label
                  className={styles.rangeCircle}
                  key={value}
                  isselected={value == selected ? "true" : "false"}
                  onClick={() => handleChange(value)}
                >
                  <input
                    name={extractContent(props.question.replace(/\s+/g, ""))}
                    className={styles.radioBtn}
                    type="radio"
                    onClick={() => handleChange(value)}
                    id={`${extractContent(
                      props.question.replace(/\s+/g, "")
                    )}-${value}`}
                    aria-describedby={props.questionId + "-error"}
                  />
                  <span
                    style={{ zIndex: 99 }}
                    key={value}
                    onClick={() => handleChange(value)}
                  >
                    {value}
                  </span>
                </label>
              </>
            ))}
          </div>
          <div className={`${styles.endpointIndicatorContainer}`}>
            <div className={styles.endpointIndicatorStart}>
              {props.endpointLow}
            </div>
            <div className={styles.endpointIndicatorEnd}>
              {props.endpointHigh}
            </div>
          </div>
        </div>
      </fieldset>
    </div>
  );
};

AnswerScaleNps.propTypes = {
  question: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
  choices: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)).isRequired,
  handleChange: PropTypes.func,
};

AnswerScaleNps.defaultProps = {
  handleChange: noop,
  required: false,
  choices: [],
};

export default AnswerScaleNps;
